import { handleActions } from "redux-actions";
import Constants from './constants';
import IConnectionState from './state';

const initialState = {
    clientId: '',
    connected: false,
    pending: true,
    reconnectionAttempts: 0,
} as IConnectionState;

export default handleActions(
    {
        [Constants.CONNECTION_PENDING]: (state:IConnectionState) => ({ ...state }),
        [Constants.CONNECTION_SUCCESS]: (state:IConnectionState) => ({ ...state, connected: true, pending: false}),
        [Constants.CONNECTION_ERROR]: (state:IConnectionState) => ({ ...state, connected: false, pending: false}),

        [Constants.ATTEMPTING_RECONNECT_PENDING]: (state:IConnectionState, payload:any) =>
            ({ ...state, connected: false, pending: true, reconnectionAttempts: payload.attempt}),
        [Constants.ATTEMPTING_RECONNECT_SUCCESS]: (state:IConnectionState) => ({ ...state, connected: true, pending: false, reconnectionAttempts: 0 }),
        [Constants.ATTEMPTING_RECONNECT_FAILED]: (state:IConnectionState) => ({ ...state, connected: false, pending: false}),

        [Constants.HELLO_SUCCESS]: (state:IConnectionState, payload:any) =>
            ({ ...state, clientId: payload.id})
    },
    initialState,
);


// WEBPACK FOOTER //
// ./src/redux/modules/connection/reducer.ts